/**
 * Shared display helpers for UnifiedMediaCard variant renderers.
 */

/** Formats raw views into compact UI notation (e.g. 1.2K, 3.4M). */
export function formatViews(count: number): string {
  if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
  if (count >= 1_000) return `${(count / 1_000).toFixed(1)}K`;
  return `${count}`;
}

/** Computes overlay opacity class from PiP and hover state. */
export function getOverlayOpacityClass(
  pipThumbnailOverlayHidden: boolean,
  isCardHovered: boolean
): string {
  if (pipThumbnailOverlayHidden) return "opacity-100";
  return isCardHovered ? "opacity-0" : "opacity-100";
}
